<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="addressTypes" formControlName="type" optionLabel="name" optionValue="value"
            placeholder="Select Address Type"></p-dropdown>
            <label for="Select Address Type">Select Address Type</label>
            @for (validation of validationMessages.type; track validation) {
              <span>
                @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrStreet" id="adrStreet" type="text" pInputText>
            <label for="adrStreet">Address Street</label>
            @for (validation of validationMessages.adrStreet; track validation) {
              <span>
                @if (form1.get('adrStreet').hasError(validation.type) && (form1.get('adrStreet').dirty || form1.get('adrStreet').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrStreet2" id="adrStreet2" type="text" pInputText>
            <label for="adrStreet2">Address Street2</label>
            @for (validation of validationMessages.adrStreet2; track validation) {
              <span>
                @if (form1.get('adrStreet2').hasError(validation.type) && (form1.get('adrStreet2').dirty || form1.get('adrStreet2').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrCity" id="adrCity" type="text" pInputText>
            <label for="adrCity">Address City</label>
            @for (validation of validationMessages.adrCity; track validation) {
              <span>
                @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="states" formControlName="adrState" optionLabel="name" appendTo="body"
              optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Select State">
            </p-dropdown>
            <label for="Select State">Select State</label>
            @for (validation of validationMessages.adrState; track validation) {
              <span>
                @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
            <label for="adrPostalCode">Address Postal Code</label>
            @for (validation of validationMessages.adrPostalCode; track validation) {
              <span>
                @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="countries" formControlName="adrCountry" optionLabel="name" appendTo="body"
              optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Select Country">
            </p-dropdown>
            <label for="Select Country">Select Country</label>
            @for (validation of validationMessages.adrCountry; track validation) {
              <span>
                @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!--<div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="persons" formControlName="personId" appendTo="body" optionLabel="name"
            optionValue="personId" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Select Person">
          </p-dropdown>
          <label for="Select Person">Select Person</label>
          <span *ngFor="let validation of validationMessages.personId">
            <small class="p-invalid"
              *ngIf="form1.get('personId').hasError(validation.type) && (form1.get('personId').dirty || form1.get('personId').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div>-->

    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (personAddressId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Address</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!personAddressId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Address</button>
            }

            @if (personAddressId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Address</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>